<script setup lang="ts">
import { computed } from 'vue';

import { avatarIdFor, avatarUrl } from './avatar-catalog';

/** seed 是稳定身份；avatar 是本人在头像库里选的编号，没选时按 seed 默认分配。 */
const props = defineProps<{ avatar?: null | string; seed: string }>();

const avatarId = computed(() => avatarIdFor(props.seed, props.avatar));
const illustration = computed(() => avatarUrl(avatarId.value));
</script>

<template>
  <span class="default-avatar" aria-hidden="true" :data-avatar="avatarId">
    <img :src="illustration" alt="" draggable="false" />
  </span>
</template>

<style scoped>
.default-avatar {
  display: inline-grid;
  place-items: center;
  flex: none;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border: 1px solid #dbecef;
  border-radius: 50%;
  background: #f2fafb;
}

.default-avatar img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
